import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

export default function Slider({ items = [], onItemClick }) {
  return (
    <div className="categories-slider-wrapper">

      <Swiper
        modules={[Navigation]}
        spaceBetween={15}
        navigation
        dir="rtl"
        breakpoints={{
          0: { slidesPerView: 2 },
          576: { slidesPerView: 3 },
          768: { slidesPerView: 4 },
          1024: { slidesPerView: 5 },
        }}
      >
        {items.map((cat, index) => (
          <SwiperSlide key={cat.id}>
            <div
              className="customer-category-box"
              onClick={() => onItemClick(cat)}
              style={{ cursor: "pointer" }}
            >
              <i className={`fa-solid ${cat.icon} category-icon`}></i>
              <p className="customer-category-name">{cat.name}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

    </div>
  );
}